import React from 'react'
import { Button, Container, Grid, Typography } from "@mui/material";
import { ArrowForward as ArrowForwardIosIcon } from "@mui/icons-material";
import Header from "../../Header";
import Slider from "react-slick";
import SliderImg from "../../../../assets/image/ezgif.com-resize-1.png";
import SliderImg2 from "../../../../assets/image/ezgif.com-resize-2.png";
import SliderImg3 from "../../../../assets/image/ezgif.com-gif-maker-5.png";
import SliderImg4 from "../../../../assets/image/ezgif.com-gif-maker-1-1.png";
import SliderImg5 from "../../../../assets/image/jjjjlogo.png";
import SliderImg6 from "../../../../assets/image/ezgif.com-gif-maker-10.png";
import SliderImg7 from "../../../../assets/image/ezgif.com-gif-maker-6.png";
import OurTeamImg from "../../../../assets/image/img_box_24.png";
import OurTeamImg2 from "../../../../assets/image/img_box_25.png";
import OurTeamImg3 from "../../../../assets/image/img_box_26.png";
import OurTeamImg4 from "../../../../assets/image/img_box_27.png";
import OurTeamBgImg from "../../../../assets/image/SMM_bg__img-scaled.png";
import KeyBnifitsImg from "../../../../assets/image/file (2).png";
import FooterSvg from "../../../../assets/image/Untitled-3.svg";
import HeroImgD from "../../../../assets/image/heroimge.png";
import DigitalCreator from "../../../../assets/image/Digital-creator.png";
import SocialPromotion from "../../../../assets/image/social-Promotion.png";

import "./WebDesign.css";
import Footer from "../../Footer";
const DigitalMarketing = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 9,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 7,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const ourTeamGridData = [
    {
      id: 1,
      imgSrc: OurTeamImg,
      color: "#695ce8",
      title: "Website Design and Development",
      description:
        "We provide robust PHP web development services to our global clients in UK, USA, and India. Our programmers are well-known for providing custom PHP solutions which are customized to match your unique business requirements.",
    },
    {
      id: 2,
      imgSrc: OurTeamImg2,
      color: "#f47514",
      title: "Web Portal Development",
      description: `Our PHP website programmers are experts in providing CRM solutions and developing custom features from scratch. Our PHP Development agency ensures that our CRM functionality works perfectly as needed by you.`,
    },
    {
      id: 3,
      imgSrc: OurTeamImg3,
      color: "#ff4a69",
      title: "Custom Development",
      description: `Our PHP experts offer cloud services like SaaS, LaaS, PaaS and many more backend solution. We provide full stack PHP web development services from initial consultation, to the final PHP application.`,
    },
    {
      id: 4,
      imgSrc: OurTeamImg4,
      color: "#38c77b",
      title: "Ecommerce Development",
      description: `We provide ecommerce PHP solutions on wordpress, laravel, magento and woocommerce. Our PHP Development company in guwahati  provides full customization services and can help you to add new features to your site .`,
    },
    {
      id: 5,
      imgSrc: OurTeamImg4,
      color: "#38c77b",
      title: "Support & Maintenance",
      description: `We provide PHP support and maintenance after project completion with 24/7 chat suppport . Our PHP team have worked with small business , large scale enterprise , or any complex business process.`,
    },
    {
      id: 6,
      imgSrc: OurTeamImg3,
      color: "#ff4a69",
      title: "ERP Solutions",
      description: `As a leading PHP application development company, we offer services like custom ERP development on wordpress, Drupal and WordPress. We create custom ERP which are secure, and fast.`,
    },
  ];

  const frontEndDemoData = [
    { id: 1, title: "Javascript", categoryId: 1 },
    { id: 2, title: "Type Script", categoryId: 1 },
    { id: 3, title: "Angular", categoryId: 1 },
    { id: 4, title: "React JS", categoryId: 1 },
    { id: 5, title: "Vue JS", categoryId: 1 },
    { id: 6, title: "Backbone js", categoryId: 1 },
    { id: 7, title: "Emberjs", categoryId: 1 },
    { id: 8, title: "Bootstrap", categoryId: 1 },
    { id: 9, title: "HTML5", categoryId: 1 },
    { id: 10, title: "CSS3", categoryId: 1 },
    { id: 11, title: "Laravel", categoryId: 2 },
    { id: 11, title: "Laravel", categoryId: 2 },
    { id: 11, title: "Laravel", categoryId: 2 },
    { id: 11, title: "Laravel", categoryId: 2 },
    { id: 11, title: "Laravel", categoryId: 2 },
    { id: 11, title: "Laravel", categoryId: 2 },
    { id: 11, title: "Laravel", categoryId: 2 },
    { id: 11, title: "Laravel", categoryId: 2 },
    { id: 11, title: "Laravel", categoryId: 2 },
    { id: 11, title: "Firebase", categoryId: 3 },
    { id: 11, title: "Firebase", categoryId: 3 },
    { id: 11, title: "Firebase", categoryId: 3 },
    { id: 11, title: "Firebase", categoryId: 3 },
    { id: 11, title: "Firebase", categoryId: 3 },
    { id: 11, title: "Firebase", categoryId: 3 },
    { id: 11, title: "Firebase", categoryId: 3 },
    { id: 11, title: "Adobe XD", categoryId: 4 },
    { id: 11, title: "Adobe XD", categoryId: 4 },
    { id: 11, title: "Adobe XD", categoryId: 4 },
    { id: 11, title: "Adobe XD", categoryId: 4 },
    { id: 11, title: "Adobe XD", categoryId: 4 },
    { id: 11, title: "Adobe XD", categoryId: 4 },
    { id: 11, title: "Adobe XD", categoryId: 4 },
    { id: 11, title: "Adobe XD", categoryId: 4 },
    { id: 11, title: "Adobe XD", categoryId: 4 },
  ];

  const titleData = [
    {
      id: 1,
      title: "Front End",
    },
    {
      id: 2,
      title: "Back End",
    },
    {
      id: 3,
      title: "Database",
    },
    {
      id: 4,
      title: "Design Tools",
    },
  ];

  const whyChooseUsData1 = [
    { id: 1, desc: "Static website Design starting at Rs. 2999" },
    { id: 2, desc: "Custom Website Designing" },
    { id: 3, desc: "Education Institute Website Design" },
    { id: 4, desc: "School Website Design" },
  ];

  return (
  
    <>
    <Header />
    <section>
      <Container>
        <Grid container spacing={0}>
          <Grid item xs={12} md={6}>
            <div style={{ textTransform: "uppercase", fontWeight: "bold" }}>
              Web Development services
            </div>
            <br />
            <Typography
              variant="h6"
              gutterBottom
              sx={{
                textTransform: "uppercase",
                fontWeight: "bold",
                color: "#3a506b",
              }}
            >
              Social Media Marketing 
            </Typography>
            <br />
            <br />
            <img src={HeroImgD} alt='Zoodonix Image' width={400}/>
          </Grid>
          <Grid item xs={12} md={6}>
            <div
              style={{
                textTransform: "uppercase",
                fontWeight: "bold",
                color: "#6254e7",
                paddingTop:'20px'
              }}
            >
              Share Your Unique Brand Story Across Online Channels
            </div>
            <h2 className='ts-18'>
            Top Social Media Marketing Company Specialized to Create Creative Branding.
            </h2>
            <p className='ts-18'>
            Does your business have the votes of confidence it needs from social media networks? Build your brand awareness across the web and create meaningful connections with your customers and followers through social media marketing (SMM). Social Media Marketing Services.
            </p>
            <p  className='ts-18'><a href="https://zoodonix.com">Zoodonix</a> Internet Marketing Agency provides social media marketing for small businesses, enterprises and multiple-location companies. No matter if you own a startup or a Fortune 500 company, our social media marketing experts can assist you with your campaign. Partner with us and let our social media marketing agency boost your brand visibility and integrity!</p>
            <Button
                style={{
                  padding: "15px 25px 15px 25px",
                  background: "#6254e7",
                  color: "white",
                  marginBottom: "20px",
                }}
                variant="contained"
                color="#7209b7"
              >
                Explore More
              </Button>
          </Grid>
        </Grid>
      </Container>
    </section>

    <section>
      <Container>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            textTransform: "uppercase",
            fontSize: "17px",
          }}
        >
          <h3 style={{ fontWeight: "bold" }}>Our Happy Clients</h3>
        </div>
        <div className="slider-container">
          <Slider {...settings}>
            <div>
              <img width={70} src={SliderImg} alt="Client 1" />
            </div>
            <div>
              <img width={70} src={SliderImg2} alt="Client 2" />
            </div>
            <div>
              <img width={70} src={SliderImg3} alt="Client 3" />
            </div>
            <div>
              <img width={70} src={SliderImg4} alt="Client 4" />
            </div>
            <div>
              <img width={70} src={SliderImg5} alt="Client 5" />
            </div>
            <div>
              <img width={70} src={SliderImg6} alt="Client 6" />
            </div>
            <div>
              <img width={70} src={SliderImg7} alt="Client 6" />
            </div>
          </Slider>
        </div>
      </Container>
    </section>

    {/* video section  */}

    <section style={{marginTop:'40px'}}>
      <Container>
        <Grid container spacing={0}>
          <Grid item xs={12} md={5}>
            <div style={{ textTransform: "uppercase", fontWeight: "bold" }}>
              Trusted Web Development services
            </div>
            <Typography
              variant="h6"
              gutterBottom
              sx={{ fontWeight: "bold", color: "#3a506b" }}
            >
              Are Digital and Social Media Marketing Essential to Business?
            </Typography>
            <p className='ts-18'>
            Yes. Digital and social media marketing are critical components of online success. Although digital and social media marketing strategies vary, these marketing tactics share the same goals: to boost brand awareness and drive more revenue.
            </p>
            <p className='ts-18'>
          Social media digital marketing allows you to showcase your brand to potential customers at exactly the moment they are ready to convert. More importantly, combined digital and social media marketing efforts enable you to maximize available customer touchpoints and conversion opportunities.
          </p>

          <p className='ts-18'>
          Remember, digital success is not a matter of choosing between digital marketing vs. social media marketing but combining the right marketing tactics to convey your brand message. Having both digital and social media marketing strategies is critical to finding the right customers and enhancing your online presence. The key is to ensure your social media digital marketing techniques match your objectives.
          </p>
          </Grid>
          <Grid item xs={12} md={7}>
            <img src={DigitalCreator}  alt='Zoodonixx Image'/>
          </Grid>
        </Grid>
        <Grid container spacing={0}>
          <Grid item xs={12} md={6}></Grid>
          <Grid item xs={12} md={6}>
            <p style={{ textTransform: "uppercase", textAlign: "center" }}>
              Web development services
            </p>
          </Grid>
          
        
        </Grid>
      </Container>
    </section>

    <section
      style={{
        backgroundImage: `url(${OurTeamBgImg})`,
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        padding: "20px",
      }}
    >
      <Container>
        <div style={{ textAlign: "center" }}>
          <div style={{ textTransform: "uppercase", fontWeight: "bold" }}>
            Best for you
          </div>
          <Typography
            variant="h5"
            gutterBottom
            sx={{ fontWeight: "bold", color: "#3a506b" }}
          >
            How Our Team Can Help
          </Typography>
          <p style={{ fontSize: "20px" }}>
            We are renowned custom web app development company in <br />{" "}
            Guwahati, offering wide range of web development services <br />{" "}
            that caters to all your business needs:
          </p>
        </div>
        <Grid container spacing={12}>
          {ourTeamGridData.map((item, index) => (
            <Grid item xs={12} md={6} key={item.id}>
              <div style={{ display: "flex", padding: "0px" }}>
                <img
                  src={item.imgSrc}
                  width={50}
                  height={50}
                  alt="Placeholder 1"
                  style={{ marginRight: "10px" }}
                />
                <div>
                  <div
                    style={{
                      fontSize: "20px",
                      fontWeight: "bold",
                      color: `${item.color}`,
                    }}
                  >
                    {"0" + item.id}
                    <br />
                    {item.title}
                  </div>
                  <p
                    className="our-team-card-description"
                    style={{
                      fontSize: "18px",
                      color: "#8d99ae",
                      marginTop: "0",
                    }}
                  >
                    {item.description}
                  </p>
                </div>
              </div>
            </Grid>
          ))}
        </Grid>
      </Container>
    </section>

  
    <section>
      <Container>
        <div
          style={{
            textAlign: "center",
            backgroundImage:
              "linear-gradient(90deg, #56ab2f 0%, #a8e063 100%)",
            padding: "20px",
            color: "#fff",
            borderRadius: "20px",
            boxShadow: "0px 0px 19px 0px rgba(0,0,0,.5)",
          }}
        >
          <p className="text-uppercase text-bold">Welcome</p>
          <Typography
            variant="h4"
            gutterBottom
            sx={{ fontWeight: "bold", color: "#fff" }}
            className="let-discuss-header"
          >
            Let's Discuss Your Project
          </Typography>
          <p className="let-discuss-para" style={{ fontSize: "18px" }}>
            We accept Mobile Application Development projects including Mobile
            App UI/UX Design from all major towns and cities of Assam
            including Guwahati, Silchar, Dibrugarh, Tezpur, Tinsukia,
            Bongaigaon, Mangaldai, Nalbari, Pathsala, Nagaon, Jorhat,
            Sivasagar, Lakhimpur, Dhekiajuli. We haved expanded our services
            to multiple cities of Northeast including Itanagar, Arunachal
            Pradesh, Imphal, Manipur, Shillong, Meghalaya, Aizawl, Mizoram,
            Agartala, Tripura, Kohima, Nagaland
          </p>
          <Button
            style={{
              padding: "15px 25px 15px 25px",
              background: "#fff",
              color: "black",
              borderRadius: "40px",
            }}
            variant="contained"
            color="#7209b7"
            className="text-uppercase"
          >
            Talk our experts
          </Button>
        </div>
      </Container>
    </section>

    <section>
      <Container>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <p className="text-uppercase text-bold">Analysis</p>
            <Typography
              variant="h6"
              gutterBottom
              sx={{ fontWeight: "bold", color: "#3a506b" }}
              className="let-discuss-header"
            >
              How to Market on Social Media
            </Typography>
            <p className="ts-18">
            Are you struggling to get the best results from your social media marketing strategy? Becoming a thought leader does not happen overnight. However, with creative social media marketing ideas and a data-driven social media marketing business approach, you can position your brand as an expert in your respective field in no time.
            </p>
            <p className="ts-18">
            From choosing the right social media channels to developing your social media content marketing strategy, every step is crucial to creating a successful social media marketing business campaign. Ready to begin marketing through social media?
            </p>
            <p className="ts-18">
            Our social media marketing firm has put together the best practices to promote your business across online platforms effectively.
            </p>
           
          </Grid>
          <Grid item xs={12} md={6}>
            <img src={SocialPromotion} alt="Reseller Bano Key Benefits"/>
          </Grid>
        </Grid>

        <p className="text-uppercase text-bold" >We are</p>
        <p className="ts-18">
        Social Media Marketing is all the rage in today. We don’t think I need to tell you how big social media is. Social media is the fastest-growing trend in the history of the world. This sector has grown faster than the Internet itself. Within the first ten years of being publicly available, the Internet managed to gather roughly 1 billion users. So, it doesn’t matter what type of business you’re or what kind of services you provide. You can always find new customers on social media.
       
        With a professional team of developers we at Reseller Bano try to provide the best web development experience to our customers. We offer various solutions to website development. If you are looking for an affordable and effective website, open source platforms can be used. The availability of variety of libraries and wonderful plugins enables effective wiring of codes. MVC frameworks like Codeigniter, Laravel or custom frameworks are useful for clients who already understand their business well and want to transfer it online. It is especially remarkable given the ease of testing with each new addition of Features. We Reseller Bano, a
        </p>
        <p className='ts-18'>
        If you are a small business and wondering if social media marketing can help you. Let me tell it, it absolutely can. People are always on their phones. Whether it be them watching a YouTube video or going through their Facebook account. In fact, people are so addicted to their mobile phones and the social media apps on them that there’s now a word for our obsession. With such widespread use, social media presents an incredible marketing opportunity. You should start using social media marketing already or you’ll lose in the long run.
        </p>
        <p className='ts-18'>One of the biggest advantages of social media is cost.<a href="https://zoodonix.com"> Social media marketing</a> is way cheaper than traditional marketing. Traditional marketing like TV ads and pamphlets can cost you more than Rs.20,000 and you don’t even have the guarantee that it will work. But with social media, you can guarantee your success. That’s because you can target your ads to a specific group of people or place. Social media can do this because they have all the user’s information with them. For example, Facebook knows a user’s behavior like what they like to eat and where they like to go. Now, this might sound scary to you, but it is true and as a business, you can take advantage of that. For example if you are a restaurant in Guwahati, you can target your Facebook ads to the people of Guwahati. This helps reduce the cost of ads considerably. You can even change the target audience for each post. You don’t get this kind of flexibility with traditional media like TV.</p>
        <img src={FooterSvg} />
      </Container>
    </section>

    <Footer/>
    </>
  )
}

export default DigitalMarketing
